import React from "react";
import { Tag } from "primereact/tag";

import { statusLabel, statusSeverity } from "../../../../utils/eroundProvisioning";

// PrimeReact's Tag has no neutral severity; these statuses are informational.
const NEUTRAL = { background: "var(--surface-300)", color: "var(--text-color)" };

/** An eRound provisioning status as a Tag (SOPS-148); a waiting station says who it waits on. */
const ProvisioningStatusTag: React.FC<{ status: string; waitingOn?: string | null }> = ({ status, waitingOn }) => {
  const severity = statusSeverity(status, waitingOn);
  return (
    <Tag value={statusLabel(status, waitingOn)} severity={severity} style={severity === null ? NEUTRAL : undefined} />
  );
};

export default ProvisioningStatusTag;
